<template>
  <div class="flex-bottom">
    <transition
      enter-active-class="animated fadeInUp"
      :duration="{ enter: 800, leave: 800 }"
      leave-active-class="animated fadeOutDown"
    >
      <div style="background: #05123e; height: 100%" v-show="!isFrom">
        <div class="close" @click="isFrom = !isFrom">
          <img src="@/assets/icon_arrowdown.png" />收起
        </div>
        <div class="from-box">
          <div class="from-content">
            <div class="from-item">
              <div class="label">姓名</div>
              <div class="from-input" :class="{ error: !isName }">
                <input
                  :placeholder="!isName ? '请输入正确姓名' : '请输入姓名'"
                  v-model="tcData.name"
                />
              </div>
            </div>
            <div class="from-item">
              <div class="label">联系电话</div>
              <div class="from-input" :class="{ error: !isTelephone }">
                <input
                  :placeholder="
                    !isTelephone ? '请输入正确联系电话' : '请输入联系电话'
                  "
                  v-model="tcData.telephone"
                />
              </div>
            </div>
            <div class="from-item">
              <div class="label">邮箱</div>
              <div class="from-input" :class="{ error: !isEmail }">
                <input
                  :placeholder="!isEmail ? '请输入正确邮箱' : '请输入邮箱'"
                  v-model="tcData.email"
                />
              </div>
            </div>
            <div class="from-item">
              <div class="label">所在城市</div>
              <div class="from-input">
                <treeselect v-model="tcData.cityCode" placeholder="请选择所在城市" :options="area"
                            :load-options="handleItemChange"
                            :disable-branch-nodes="true"
                            :clearable="false"
                            @select="handChange"
                />
              </div>
            </div>
          </div>
          <div class="btn-describe">
            <span
              >友情提示：我公司在收到您的申请后，在两个工作日内将有专业人士与您联系,请您务必认真填写,感谢您的信任。</span
            >
            <span class="btn" @click="submitTz()">提交</span>
          </div>
        </div>
      </div>
    </transition>
    <transition
      enter-active-class="animated fadeIn"
      :duration="{ enter: 800, leave: 800 }"
      leave-active-class="animated fadeOut"
    >
      <div v-if="isFrom">
        <div class="flex-bottom-btn">
          <div class="btn" @click="isFrom = !isFrom">{{ btnText }}</div>
        </div>
      </div>
    </transition>
    <tip :isShow="isShow" :tip="tip" :isSuccess="isSuccess"></tip>
  </div>
</template>
<script>
import Axios from "axios";
// import the component
import Treeselect from '@riophae/vue-treeselect'
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'

export default {
  name: "from-bottom",
  components: { Treeselect },
  data() {
    return {
      isFrom: true,
      tip: "保存中...",
      isShow: false,
      isSuccess: "save",

      isName: true, //姓名
      isTelephone: true, //
      isEmail: true, //
      isCity: true, //
      mIsCity: true,
      mj: 200,
      gm: 1,
      hzms: "a",
      value: null,
      area:[],
    };
  },
  props: {
    tcData: null,
    btnText: {
      type: String,
      default: "我要投资",
    },
  },
  methods: {
    jyName() {
      if (
        this.tcData.name.trim().length < 1 ||
        this.tcData.name.trim().length > 10
      ) {
        this.tcData.name = "";
        this.isName = false;
      } else {
        this.isName = true;
      }
    },
    jyTelephone() {
      if (!/^1[3456789]\d{9}$/.test(this.tcData.telephone)) {
        this.tcData.telephone = "";
        this.isTelephone = false;
      } else {
        this.isTelephone = true;
      }
    },
    jyEmail() {
      const myReg = /^[a-zA-Z0-9_-]+@([a-zA-Z0-9]+\.)+(com|cn|net|org)$/;
      if (!myReg.test(this.tcData.email)) {
        this.tcData.email = "";
        this.isEmail = false;
      } else {
        this.isEmail = true;
      }
    },
    submitTz() {
      console.log(this.tcData)
      this.jyName();
      this.jyTelephone();
      this.jyEmail();
      if (!this.isName || !this.isTelephone || !this.isEmail) return;
      this.isShow = true;
      this.isSuccess = "save";

      Axios.post(
        "https://www.aostarit.com.cn/sjxn-website-service/registration/save",
        this.tcData
      )
        .then((res) => {
          this.isSuccess = "success";
          this.tip = "提交成功!";
          setTimeout(this.close, 2000);
          this.tcData.name = "";
          this.tcData.telephone = "";
          this.tcData.email = "";
          this.tcData.cityCode = "510000";
          this.tcData.city = "四川省";
        })
        .catch((error) => {
          this.isSuccess = "error";
          this.tip = "提交失败，请重试";
          setTimeout(this.close, 2000);
        });
    },
    getData() {
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/primary/infos"
      ).then((res) => {
        let data = res.data
        if(data.success){
          data.data.map(item => {
            if(
              item.areaId === "820000" ||
              item.areaId === "810000" ||
              item.areaId === "710000"
            ){
              this.area.push({
                id: item.areaId,
                label: item.areaName
              });
            }else if(
              item.areaId === "510000"
            ){
              this.handleItemChangeInit({
                id: item.areaId,
                label: item.areaName,
                children: []
              })
            }else {
              this.area.push({
                id: item.areaId,
                label: item.areaName,
                children: null
              });
            }
          });
        }
      }).catch();
    },
    handChange($event){
      this.tcData.city =$event.label
    },
    handleItemChange({ action, parentNode, callback }) {
      let me = this;
      let areaId = parentNode.id;
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/subordinate/infos?areaId="+ areaId
      ).then((res) => {
        let data = res.data
        if(data.success){
          me.area.map(item => {
            if (item.id === areaId) {
              item.children = data.data.map(vv=> {
                return {
                  id: vv.areaId,
                  label: vv.areaName,
                }
              });
            }
          });
          callback()
        }
      }).catch();
    },
    handleItemChangeInit(row) {
      let me = this;
      let areaId = 510000;
      Axios.post(
        "https://www.aostarit.com.cn/icity-mgrserver/station/subordinate/infos?areaId="+ areaId
      ).then((res) => {
        let data = res.data
        if(data.success){
          row.children = data.data.map(vv=> {
            return {
              id: vv.areaId,
              label: vv.areaName,
            }
          });
          me.area.push(row)
        }
      }).catch();
    },
    close() {
      this.isShow = false;
    },
    gotoPage() {
      this.$router.push({
        name: "mobileApply",
        params: this.tzData,
      });
    },
  },
  mounted() {
    if(this.tcData){
      this.tcData.cityCode = "510100";
      this.tcData.city = "四川省成都市";
    }
    this.getData();
  }
};
</script>

<style scoped lang="less">
.flex-bottom {
  z-index: 999;
  position: fixed;
  width: 100%;
  height: 180px;
  left: 0;
  bottom: 0;
  .close {
    width: 60px;
    height: 14px;
    line-height: 2;
    font-size: 14px;
    color: #7b9aeb;
    cursor: pointer;
    position: absolute;
    left: calc(50% - 30px);
    text-align: center;
    img {
      margin-right: 6px;
      position: relative;
      top: -1px;
    }
  }
  .from-box {
    width: 1100px;
    height: 100%;
    margin: 0 auto;
    .from-content {
      width: 1100px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      flex-flow: row;
      margin-top: 10px;
      padding: 34px 0px;
      .from-item {
        .label {
          line-height: 20px;
          text-align: left;
          padding-left: 16px;
          font-size: 14px;
          font-weight: 400;
          color: rgba(114, 143, 220, 1);
        }
        .from-input {
          .vue-treeselect div, .vue-treeselect span{
            color: #7b9aeb;
          }
          ::v-deep .vue-treeselect {
            .vue-treeselect__x-container{
              color: #7b9aeb!important;
            }
            .vue-treeselect__control{
              background-color: #000;
              border: none;
            }
            .vue-treeselect__placeholder{
              color: #7b9aeb;
            }
            .vue-treeselect__single-value{
              color: #7b9aeb;
              line-height: 42px;
            }
            .vue-treeselect__placeholder{
              color: #7b9aeb;
              line-height: 42px;
            }
          }
          ::v-deep .vue-treeselect {
            width: 240px;
            height: 42px;
            outline: none;
            background-color: #000;
            color: #7b9aeb;
            padding: 0px 10px;
            border-radius: 8px!important;
            border: 1px solid #05123e;
            line-height: 42px;
            font-size: 16px;
          }
          input {
            width: 240px;
            height: 42px;
            background: rgba(11, 16, 32, 1);
            border-radius: 8px;
            outline: none;
            background-color: #000;
            color: #7b9aeb;
            padding: 0px 10px;
            border: 1px solid #05123e;
            line-height: 42px;
            font-size: 16px;
          }
          ::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #7b9aeb;
            font-size: 16px;
          }
          ::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #7b9aeb;
            font-size: 16px;
          }
          :-ms-input-placeholder {
            /* Internet Explorer 10+ */
            color: #7b9aeb;
            font-size: 16px;
          }
        }
        .from-input.error {
          input {
            background-color: #000;
            border: 1px solid #fe3355;
          }
          ::-webkit-input-placeholder {
            /* WebKit browsers */
            color: #fe3355;
          }
          ::-moz-placeholder {
            /* Mozilla Firefox 19+ */
            color: #fe3355;
          }
          :-ms-input-placeholder {
            /* Internet Explorer 10+ */
            color: #fe3355;
          }
        }
      }
    }
    .btn-describe {
      width: 1100px;
      margin: 0 auto;
      color: #526bab;
      font-size: 14px;
      text-align: left;
      line-height: 30px;
      margin-top: -10px;
      .btn {
        background: -webkit-linear-gradient(90deg, #099aff, #3afefe);
        /* Safari 5.1 - 6.0 */
        background: -o-linear-gradient(90deg, #099aff, #3afefe);
        /* Opera 11.1 - 12.0 */
        background: -moz-linear-gradient(90deg, #099aff, #3afefe);
        /* Firefox 3.6 - 15 */
        background: linear-gradient(90deg, #099aff, #3afefe);
        float: right;
        color: #fff;
        font-weight: 500;
        text-align: center;
        border-radius: 25px;
        cursor: pointer;
        font-size: 20px;
        color: rgba(255, 255, 255, 1);
        line-height: 42px;
        width: 160px;
        height: 42px;
        margin-top: -10px;
      }
    }
  }
}
.flex-bottom-btn {
  z-index: 999;
  position: fixed;
  background: transparent;
  width: 100%;
  height: 5.4rem;
  left: 0;
  bottom: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  .btn {
    background: -webkit-linear-gradient(90deg, #099aff, #3afefe);
    background: -o-linear-gradient(90deg, #099aff, #3afefe);
    background: -moz-linear-gradient(90deg, #099aff, #3afefe);
    background: linear-gradient(90deg, #099aff, #3afefe);
    box-shadow: 0px 10px 20px 0px rgba(9, 154, 255, 0.2);
    color: #fff;
    font-weight: 500;
    text-align: center;
    border-radius: 25px;
    cursor: pointer;
    font-size: 20px;
    width: 220px;
    height: 50px;
    line-height: 50px;
  }
}
</style>
